import { render, staticRenderFns } from "./ListUser.vue?vue&type=template&id=bba960a6&scoped=true"
import script from "./ListUser.vue?vue&type=script&lang=js"
export * from "./ListUser.vue?vue&type=script&lang=js"
import style0 from "./ListUser.vue?vue&type=style&index=0&id=bba960a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba960a6",
  null
  
)

export default component.exports